module.exports = __webpack_public_path__ + "static/img/Inspection12.1c981c87.jpg";